var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{class:'plausible-event-name=' + _vm.trackingEventName.replace(/\s/g, '+'),style:(_vm.hasButton && 'text-decoration: none'),attrs:{"href":_vm.redirectUrl},on:{"click":function($event){!_vm.isLoggedIn && $event.preventDefault() || _vm.onClick()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }